module.exports = __webpack_public_path__ + "img/bj.b614d76f.png";